import { ref, watch } from 'vue';

const SELECTED_YEAR_KEY = 'feesurvey_selected_year';
export const DEFAULT_YEAR = '2026';
export const AVAILABLE_YEARS = ['2026', '2022', '2019'];

const selectedYear = ref(typeof localStorage !== 'undefined' ? (localStorage.getItem(SELECTED_YEAR_KEY) || DEFAULT_YEAR) : DEFAULT_YEAR);

// Validation: ensure loaded year is valid, else reset
if (!AVAILABLE_YEARS.includes(selectedYear.value)) {
  selectedYear.value = DEFAULT_YEAR;
}

watch(selectedYear, (newValue) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(SELECTED_YEAR_KEY, newValue);
  }
});

export function useYear() {
  return {
    selectedYear,
    availableYears: AVAILABLE_YEARS
  };
}
